import React from 'react';
import Grid from '@mui/material/Grid';

const ShippingDetailHeaderComponent = () => {
  return (
    <Grid container className='page-header'>
      <Grid item size={{ xs: 12 }}>
        <Grid container direction={'row'}>
          <Grid item size={{ xs: 6 }} textAlign={'start'}>
            <h3>Detalle de envíos</h3>
          </Grid>
          <Grid item size={{ xs: 6 }} textAlign={'end'}>
            {/* <button
                            className="right openModalBtn"
                            onClick={() => {
                                setModalOpen(true);
                            }}
                        >
                            <AddIcon className="svg" />
                            Nuevo Ticket
                        </button> */}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ShippingDetailHeaderComponent;
